import SingleColumn from "@/views/SingleColumn.vue";
import SharePoints from "@/components/User/PointsOverview/SharePoints.vue";
import PayoutsHistory from "@/components/User/PointsOverview/PayoutsHistory.vue";

export default [
  {
    path: "/share-points/form",
    name: "share_points",
    component: SingleColumn,
    props: {
      content: SharePoints,
      switchOrderMobile: true,
    },
    meta: {
      requiredLang: ["de", "nl", "ch"],
      permission: "share.points",
    },
  },
  {
    path: "/payouts",
    name: "payouts",
    component: SingleColumn,
    props: {
      content: PayoutsHistory,
      switchOrderMobile: true,
    },
    meta: {
      requiredRole: ["dealer"],
      permission: "kickBackFeeBox.see",
    },
  },
];
